import React from 'react';
import { KTIcon, enumPolicies } from '../../../../_metronic/helpers';
import PolicyChecker from '../../../../_metronic/helpers/components/PolicyChecker';

const CategoryListTable = ({ data, intl, onEdit, onDelete }) => {

    const renderActions = (item) => {
        return (
            <td>
                <button className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1' onClick={() => onEdit(item)}>
                    <KTIcon iconName='pencil' className='fs-3' />
                </button>
                <button className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm' onClick={() => onDelete(item.id)}>
                    <KTIcon iconName='trash' className='fs-3' />
                </button>
            </td>
        )
    }

    return (
        <div className='table-responsive'>
            <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                <thead>
                    <tr className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                        <th>#</th>
                        <th>{intl.formatMessage({ id: 'CATEGORY.NAME' })}</th>
                        <PolicyChecker policies={[enumPolicies.ProductEdit, enumPolicies.ProductWrite]}>
                            <th>{intl.formatMessage({ id: 'CATEGORY.ACTIONS' })}</th>
                        </PolicyChecker>
                    </tr>
                </thead>
                <tbody className='text-gray-600 fw-bold'>
                    {
                        data && data.map((item, index) => {
                            return (
                                <tr key={item.id}>
                                    <td>
                                        {++index}
                                    </td>
                                    <td>{item.name}</td>
                                    <PolicyChecker policies={[enumPolicies.ProductEdit, enumPolicies.ProductWrite]}>
                                        {renderActions(item)}
                                    </PolicyChecker>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default CategoryListTable;
